import s from "../product.module.css";
import upper from "../../../../img/categories/upperarrow.svg";
import lower from "../../../../img/categories/lowerarrow.svg";
import BuyButton from "../../../../assets/Components/StyledComponents/BuyButton";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {orderCounter, setOrder} from "../../../../store/OrderSlice";
import {setUserInfo} from "../../../../firebase";
import {checkData} from "../../../../assets/Tools/checkData";
import PopUp from "../../../../assets/Components/popUp/PopUp";


const ProductOrder = ({data, togglePopUp}) => {
    const [productsCount, setProductsCount] = useState(1);
    const dispatch = useDispatch();
    const userId = useSelector(state => state.authUser.userId);
    const ordersCount = useSelector(state => state.setOrder.productsToOrder);


    return (<div className={s.productOrder}>
        <div className={s.productCount}>
            <span>{productsCount}</span>
            <div>
                <img src={upper} onClick={() => setProductsCount(productsCount + 1)} alt=""/>
                <img src={lower}
                     onClick={() => productsCount > 1 ? setProductsCount(productsCount - 1) : null}
                     alt=""/>
            </div>
        </div>
        <BuyButton onClick={() => {
            data.count = productsCount;
            data.orderName = `order${ordersCount + 1}`;
            dispatch(setOrder(data));
            dispatch(orderCounter());
            setUserInfo(userId, {
                [`Order`]: {[`order${ordersCount + 1}`]: data}
            });
            setUserInfo(userId, {ordersCount: ordersCount + 1});
            togglePopUp(true, "Товар добавлен в корзину!");
        }
        }>Купить</BuyButton>
        <BuyButton fastorder>Быстрый заказ</BuyButton>
    </div>)
}


export default ProductOrder;